import React from 'react';
import { StackItemShim as StackItem, StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { makeStyles } from '@fluentui/react-components';

interface IPageHeaderProps {
  title: string;
  actionButtons?: JSX.Element;
}

const useStyles = makeStyles({
  buttonContainer: { marginTop: '-5px' },
});

const PageHeaderWithActionButtons: React.FunctionComponent<IPageHeaderProps> = (
  props: IPageHeaderProps,
) => {
  const { title, actionButtons } = props;
  const classes = useStyles();

  return (
    <Stack horizontal horizontalAlign="space-between" wrap>
      <h1>{title}</h1>
      <Stack
        grow
        horizontal
        verticalAlign="center"
        horizontalAlign="end"
        className={classes.buttonContainer}
      >
        <StackItem>{actionButtons}</StackItem>
      </Stack>
    </Stack>
  );
};

export default PageHeaderWithActionButtons;
